export default __webpack_public_path__ + "static/media/icon-pin-amber.a3df1696.svg";